import { UntypedFormGroup, UntypedFormControl, } from '@angular/forms';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Authenticationservice } from '../../services/authentication.service';
import { NgxSpinnerService } from 'ngx-spinner';
import axios from 'axios';
import { not } from '@rxweb/reactive-form-validators';
declare var $: any;
@Component({
  selector: 'app-editplantcanein',
  templateUrl: './editplantcanein.component.html',
  styleUrls: ['./editplantcanein.component.css']
})
export class EditplantcaneinComponent implements OnInit, OnDestroy {
  //@ViewChild('dataCanein', {static:false}) dataCaneinTable:any;
  userdata: any;
  supcode: string;
  supzone: string;
  setEdit: boolean;
  Editplantdata: UntypedFormGroup;
  constructor(private auth: Authenticationservice, private spinner: NgxSpinnerService) {
    this.userdata = this.auth.Authention();

    console.log('userdata:', this.userdata);
    this.Editplantdata = new UntypedFormGroup({
      secode: new UntypedFormControl(),
      newplantno: new UntypedFormControl(),
    })
  }
  year = { "code": '2526', "code_th": '6869', "desc": "ปีพศ.2568-2569" }

  params_like1 = {
    search: '', pageSize: 15, col_like_n: []
  };

  ngOnInit(): void {
    let s_auth = this.userdata;
    this.supcode = s_auth.supcode;
    this.supzone = s_auth.zonedata;
    //this.setEdit = f;
    if (s_auth.userlevel == '15') {
      this.setEdit = true;
    }
    /*if (s_auth.supcode == '919' || s_auth.supcode == '928') {
      this.setEdit = true;
    }
    else this.setEdit = false;*/
    //console.log('setEdit:', this.setEdit);

  }
  hurl = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/';

  data_list: any[] = [];
  LoadDataLike1() {
    let search = this.params_like1.search.trim();

    let url = `${this.hurl}function-3/datatable_w`; // เปลี่ยนเป็น URL ของ Cloud Function
    const params = {
      table: `dbo.v_farmer_basic`,
      column: '[fmcode_b1],[fmcode],[fmname],[SUPZONE],[farmer_id]',
      col_like: 'fmcode_b1,fmname',
      length: 15,
      search: search,
      orderColumn: 1,
    };
    if (search.length > 0) {
      this.loading[0] = true;
      axios.get(url, { params })
        .then(res => {
          const data = res.data;
          this.loading[0] = false;
          this.data_list = data.data;
          console.log('farmer_list:', data);
        }).catch(err => { throw err })
    }
    else {
      this.data_list = [];
    }
  }

  text_f: string;
  loading: boolean[] = [false, false, false, false];
  dataoneedit: any = {};
  plantoneedit = '';
  Openmodal(data) {
    $("#Editdata").modal('show');
    this.dataoneedit = {
      ...data,
      area_id_e: data.area_id,
      note_e: data.note || ''
    };
    this.plantoneedit = data.landno;
    console.log('dataoneedit:', this.dataoneedit);
  }
  // ข้อมูลคิวชาวไร่
  fm_data: any = {};
  text_fm: string;
  fmname = ''

  async selectOption(list: any, num: number) {
    this.fm_data = list;
    const date = new Date();
    this.params_like1.search = `[${list.fmcode}] ชื่อ:${list.fmname}, โซน:${list.SUPZONE}`;
    this.data_list = [];
    console.log('Select option:list', list);
    await this.Loadfarmerplant();
    await this.LoadDataPlantbyfamer()
  }

  farmerplantlist: any[] = [];
  unfarmerplantlist: any;
  async Loadfarmerplant() {
    const farmer_id = this.fm_data.farmer_id;
    this.fmname = this.fm_data.fmname;
    this.farmerplantlist = [];
    //'https://asia-southeast2-brr-farmluck.cloudfunctions.net/app_farmer/v_qcard_wgt_v2?FMCODE_b1='+code
    let url = `${this.hurl}app_farmer/select_s_f_w_0`
    const paramss = {
      s: '*',
      f: `[dbQBRD].[dbo].[v_qcard${this.year.code}]`,
      w: `[wgt_net]>0and[farmer_id]=${farmer_id} order by[date_in]`
    };
    axios.get(url, { params: paramss })
      .then(async res => {
        let data = res.data;
        data = data.map((item: any) => (
          { ...item, area_id_e: item.area_id, note_e: item.note }
        ));
        //data = data.sort(function (a, b) { return b.date_in - a.date_in });
        this.farmerplantlist = data;
        //this.unfarmerplantlist = new MatTableDataSource(this.farmerplantlist);        
      })
      .catch(err => { throw err })
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.unfarmerplantlist.filter = filterValue.trim().toLowerCase();
  }

  // ข้อมูลแปลงชาวไร่
  dataplantfarmaer: any[] = [];
  async LoadDataPlantbyfamer() {
    let code = this.fm_data.farmer_id;
    if (code > 0) {
      let url = `${this.hurl}app_farmer/select_s_f_w_0`
      const paramss = {
        s: '[id],[year],[intlandno],[fmname],[supzone],[canein],[landvalue],[canetype]',
        f: `[dbintechgen3].[dbo].[v_areas_basic]`,
        w: `[production_year_id]=9and[status]=2and[farmer_id]=${code}`
      };
      axios.get(url, { params: paramss })
        .then(res => {
          const data = res.data.map((item: any) => ({
            ...item,
            area_id: item.id
          }));
          this.dataplantfarmaer = data;
          console.log('ข้อมูลแปลงชาวไร่:', data);
        })
        .catch(err => { throw err })
    }
  }

  // บันทึกแปลงใหม่
  SaveData() {
    const data = this.dataoneedit;
    const selected = this.dataplantfarmaer.find(p => p.area_id === data.area_id_e);
    if (!selected) {
      alert('กรุณาเลือกหมายเลขแปลงใหม่');
      return;
    }
    if (data.area_id === data.area_id_e) {
      alert('กรุณาเลือกหมายเลขแปลงใหม่');
      return;
    }
    if (!data.note_e || !data.note_e.trim()) {
      alert('กรุณาระบุหมายเหตุ');
      return;
    }

    const url = `${this.hurl}function-3/update_t_s_w?`
      + `t=[dbQBRD].[dbo].[qcard_${this.year.code_th}]`
      + `&s=area_id=${selected.area_id},landno=${selected.intlandno},note='${data.note_e.trim()}'`
      + `&w=truck_q='${data.truck_q}'`


    this.spinner.show();
    axios.put(url)
      .then(async res => {
        this.spinner.hide();
        if (res && res.status === 200) {
          alert('แก้ไขหมายเลขแปลงแล้ว');
          this.plantoneedit = null;
          setTimeout(() => {
            this.Loadfarmerplant();
          }, 500);
        }
        else {
          alert('ไม่สำเร็จกรุณาลองใหม่');
        }
      }).catch(err => { throw err })
      .finally(() => this.Closemodal());
  }

  Closemodal() {
    $("#Editdata").modal('hide');
  }

  date2th(date: string) {
    if (!date) return '';
    const date1 = new Date(date);
    let options: any = {
      year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit"//, timeZone: 'UTC'
    };
    return date1.toLocaleString('th-TH', options);
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.farmerplantlist = null;
    this.dataoneedit = null;
    this.plantoneedit = null;
    this.dataplantfarmaer = null;
  }

}
